// extracted by mini-css-extract-plugin
export default {"wrapper":"EcgUpload_wrapper__TUkfr","noEcgNotice":"EcgUpload_noEcgNotice__gbNES"};